module.exports = __webpack_public_path__ + "media/images/indicators/norain-c6a434d12f4cdc8f37e99137e30a807e.png";